import { downloadPath } from "./downloadLinks";

// The site's own store buttons go through /download/site, so every click is
// logged with source "site" and the store links carry the campaign tags.
// See src/utils/downloadLinks.js and src/Pages/DownloadRedirect.jsx.
export const APP_STORE_DOWNLOAD_PATH = downloadPath("ios");
export const GOOGLE_PLAY_DOWNLOAD_PATH = downloadPath("android");
// APK download info is read at runtime from public/apk/release.json
// See src/utils/useApkRelease.js
// Env-only. Unset means there is no public invite and hasTestFlightInvite() is false.
export const TESTFLIGHT_URL = (process.env.REACT_APP_TESTFLIGHT_URL || "").trim();

export function isAppleMobileDevice() {
  if (typeof navigator === "undefined") {
    return false;
  }

  const userAgent = navigator.userAgent || navigator.vendor || "";
  const platform = navigator.platform || "";
  const touchPoints = navigator.maxTouchPoints || 0;

  return /iPhone|iPad|iPod/i.test(userAgent) || (platform === "MacIntel" && touchPoints > 1);
}

export function getAppStoreHref() {
  return APP_STORE_DOWNLOAD_PATH;
}

// Apple mobile devices leave the page for the App Store in the same tab; every
// other browser keeps the site open and uses a new tab.
export function getAppStoreLinkProps() {
  const opensInNewTab = !isAppleMobileDevice();

  return {
    href: getAppStoreHref(),
    target: opensInNewTab ? "_blank" : undefined,
    rel: opensInNewTab ? "noreferrer" : undefined,
  };
}

export function hasTestFlightInvite(url = TESTFLIGHT_URL) {
  return /^https:\/\/testflight\.apple\.com\/join\/[A-Za-z0-9]+\/?$/.test(url);
}
